import { useTableFilter } from '@welbe/web-design-system';
import { handleToast } from 'helpers/handleToast';
import { useState } from 'react';
import { getAccessManagement } from '../Users.services';
import { patchDoctorStatus } from './DoctorDrawer/DoctorDrawer.services';
import { Doctor } from './DoctorDrawer/DoctorDrawer.types';

export const useDoctor = () => {
	const [selectedUser, setSelectedUser] = useState<Doctor>();
	const [isUserModalVisible, setUserModalVisible] = useState<boolean>(false);

	const {
		filters,
		data,
		loading,
		totalAmount,
		currentPage,
		handleSearch,
		handleFilters,
		handleChangePage,
	} = useTableFilter({
		service: getAccessManagement,
		instantSearch: ['status', 'branchOfficeId', 'pageSize', 'pageNumber'],
		tableFilters: {
			name: '',
			status: '',
			branchOfficeId: '',
			pageSize: 50,
			pageNumber: 0,
			type: 'doctor',
		},
	});

	const handleEditUser = (userInfo: any) => {
		setSelectedUser(userInfo);
		setUserModalVisible(true);
	};

	const handleToggleUserModal = (open: boolean) => {
		if (!open) setSelectedUser(undefined);
		setUserModalVisible(open);
	};

	const handleToggleStatus = async (id: string, active: boolean) => {
		try {
			await patchDoctorStatus(id, active);
			handleToast(
				'success',
				active ? 'Usuario activado' : 'Usuario desactivado',
			);
			handleSearch();
		} catch (error) {
			handleToast('error', 'Hubo un error al actualizar el estado del usuario');
			throw error;
		}
	};

	return {
		selectedUser,
		isUserModalVisible,
		setUserModalVisible,
		handleEditUser,
		handleToggleUserModal,
		handleToggleStatus,
		data,
		loading,
		totalAmount,
		currentPage,
		handleSearch,
		handleFilters,
		handleChangePage,
		filters,
	};
};
